import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TablePagination from '@material-ui/core/TablePagination';
import withWidth from '@material-ui/core/withWidth';
import StockDetail from '../mobile/StockDetail'
import BColor from '../BColor'
import BSmallBigSetting from './BSmallBigSetting';
import Typography from '@material-ui/core/Typography';
import MyLoveList from '../mylove/MyLoveList';
import FavoriteBorder from '@material-ui/icons/Build'
import { exportExcel } from '../util/ExportCSV'
import Divider from '@material-ui/core/Divider';


function desc(a, b, orderBy) {
    if (b.ebs != undefined && a.ebs != undefined && b.ebs[orderBy] < a.ebs[orderBy]) {
        return -1;
    }
    if (b.ebs != undefined && a.ebs != undefined && b.ebs[orderBy] > a.ebs[orderBy]) {
        return 1;
    }

    return 0;
}


function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) =>
        [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: '股票代號', sid: 'name' },

    { id: 'ymd', numeric: false, disablePadding: false, label: '日期', sid: 'ymd' },
    { id: 't1', numeric: false, disablePadding: false, label: '交易量', sid: 't1' },
    { id: 'sb1i', numeric: false, disablePadding: false, label: '狀態', sid: 'sb1i' },
    { id: 'sb1', numeric: false, disablePadding: false, label: '散戶買超', sid: 'sb1' },
    { id: 'ss1', numeric: false, disablePadding: false, label: '散戶賣超', sid: 'ss1' },
    { id: 'sbs1', numeric: false, disablePadding: false, label: '散戶買賣超', sid: 'sbs1' },
    { id: 'bb1', numeric: false, disablePadding: false, label: '大戶買超', sid: 'bb1' },
    { id: 'bs1', numeric: false, disablePadding: false, label: '大戶賣超', sid: 'bs1' },
    { id: 'bbs1', numeric: false, disablePadding: false, label: '大戶買賣超', sid: 'bbs1' },

    { id: 'msb1i', numeric: false, disablePadding: false, label: '狀態', sid: 'msb1i' },
    { id: 'msb1', numeric: false, disablePadding: false, label: '散戶買超', sid: 'msb1' },
    { id: 'mss1', numeric: false, disablePadding: false, label: '散戶賣超', sid: 'mss1' },
    { id: 'msbs1', numeric: false, disablePadding: false, label: '散戶買賣超', sid: 'msbs1' },
    { id: 'mbb1', numeric: false, disablePadding: false, label: '大戶買超', sid: 'mbb1' },
    { id: 'mbs1', numeric: false, disablePadding: false, label: '大戶賣超', sid: 'mbs1' },
    { id: 'mbbs1', numeric: false, disablePadding: false, label: '大戶買賣超', sid: 'mbbs1' },

    { id: 'love', numeric: false, disablePadding: false, label: '自選清單' },
];

const color1 = BColor.blue1color// "#e0757e"
const color2 = BColor.column
const color3 = BColor.blackcolor


function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const handleOk = () => {
        setOpen(false);
        setOpen1(false);
        props.freecashupdate()
    };

    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead style={{ background: color1 }}>
            <BSmallBigSetting open={open} handleClose={handleClose} handleOk={handleOk}></BSmallBigSetting>

            <TableRow style={{}}>
                <TableCell className={classes.stickya1} colSpan={1} style={{ color: "#FFFFFF", borderRight: '1px solid #dbdbdb' }}>股票名稱</TableCell>
                <TableCell className={classes.stickya} colSpan={9} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">依成交張數
                    <Typography size="small" variant="caption" style={{ fontSize: 10, color: '#e8e8e8', marginLeft: 8 }} className={classes.button1} onClick={handleClickOpen}>
                        調整參數
                    </Typography>
                </TableCell>
                <TableCell className={classes.stickya} colSpan={7} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">依成交金額</TableCell>
                <TableCell className={classes.stickya} colSpan={1} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center"></TableCell>
            </TableRow>
            <TableRow style={{}}>
                {headCells.map(headCell => (
                    <TableCell
                        // style={{ margin: 0, paddingTop: 5, paddingBottom: 5, paddingLeft: headCell.paddingLeft, paddingRight: headCell.paddingRight }}
                        key={headCell.id}
                        className={(headCell.id === 'name' ? classes.stickyhh : classes.stickyh)}
                        style={{ ...((headCell.id === 'ymd' || headCell.id === 'msb1i' || headCell.id === 'love') ? { borderLeft: '1px solid #dbdbdb' } : {}) }}
                        size="small"
                        align={headCell.id === 'name' ? 'left' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >{headCell.id === 'love' ? <div style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }}>{headCell.label}</div> :
                        <TableSortLabel
                            style={{ whiteSpace: 'nowrap', ...(headCell.id === 'name' ? { width: 10 } : {}), }}
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.sid)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        padding: 0,
        margin: 0,
        // marginTop: theme.spacing(1),
    },
  paper: {
    width: '100%',
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        // maxHeight: 550,
        overflowX: 'auto'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    vvvv: {
        fontSize: 10,
        padding: 5,
        color: BColor.faircolor,
        overflow: 'visible'
    },
    button1: {
        minWidth: 110,
    },
    button2: {
        minWidth: 90,
    },
    button3: {
        minWidth: 181,
    },
    stickyc: {
    paddingLeft: 10,
    paddingRight: 5,
    width: 10,
    whiteSpace: 'nowrap',
    position: '-webkit-sticky',
    position: 'sticky',
    zIndex: 1,
    left: 0,
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    stickya: {
        background: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 10,
        top: 0,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0,
        borderBottom: '1px solid #dbdbdb'
    },
stickyh: {
    backgroundColor: theme.palette.type === "light" ? color2 : "#000000",
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: 10,
        top: 37,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0
    }, //This is header
    stickya1: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 20,
        top: 0,
        left: 0,
        paddingTop: 7,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderBottom: '0px solid #dbdbdb'
    },
    stickyhh: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        top: 37,
        left: 0,
        zIndex: 20,
        paddingTop: 0,
        paddingBottom: 7,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderTop: '0px',
        borderRight: '1px solid #dbdbdb',
        borderBottom: '1px solid #dbdbdb'
    }
}));



function BSmallBigDetail(props) {
    const classes = useStyles();
    const loveItems = localStorage.getItem('love_stock') != null ? JSON.parse(localStorage.getItem('love_stock')) : []

    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('');
    const [selected, setSelected] = React.useState(loveItems);
    const [page, setPage] = React.useState(props.currentpage);
    const [dense, setDense] = React.useState(props.dense);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.currentcount);

    const [getStock, setSavestock] = React.useState(null);

    const [opendetail, setOpendetail] = React.useState(false)
    const [stockno, setStockNo] = React.useState(null);

    const [openstock, setOpenstock] = React.useState(null);
    const [lovemenu, setLovemenu] = React.useState(false)
    const myContainer = React.useRef(null);


    const handleLoveClick = stockNo => event => {
        setSavestock(stockNo);
        setLovemenu(true);
    };

    const handleLoveClose = () => {
        setLovemenu(false);
    };

    function getRowPageData(screen) {
        if (screen === 'xs')
            return [20]
        else return [10, 20, 40, 80, 150];
    }


    const rows = props.data

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.stock_no);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        props.pageupdate(newPage, props.currentcount)
    };

    const handleChangeRowsPerPage = event => {
        setPage(0)
        setRowsPerPage(parseInt(event.target.value, 10));
        props.pageupdate(0, parseInt(event.target.value, 10))
    };



    function render1(value, unit) {
        let color = BColor.faircolor

        if (value > 0) {
            color = BColor.upcolorbox
        } else if (value < 0) {
            color = BColor.downcolorbox
        }

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0 }} size="small" align="left">
            <Button size="small" variant="outlined" style={{ minWidth: 110, color: color, marginRight: 1, marginLeft: 1 }} className={classes.button2} >
                {value}{unit}
            </Button>
        </TableCell>
    }


    function render2(index, divid) {
        let color = BColor.faircolor
        let value = '-'
        let border = ''

        if (divid) border = '1px solid #dbdbdb'

        if (index === 0) {
            value = '散戶賣 -> 大戶買'
            color = BColor.upcolor
        } else if (index === 1) {
            value = '大戶賣 -> 散戶買'
            color = BColor.downcolor
        } else if (index === 2) {
            value = '散戶跟大戶都買'
            color = BColor.upcolor
        } else if (index === 3) {
            value = '散戶跟大戶都賣'
            color = BColor.downcolor
        } else if (index === 4) {
            value = '散戶跟大戶都中立'
        } else if (index === 5) {
            value = '大戶買超'
            color = BColor.upcolor
        } else if (index === 6) {
            value = '大戶賣超'
            color = BColor.downcolor
        } else if (index === 7) {
            value = '散戶賣超'
            color = BColor.downcolor
        } else if (index === 8) {
            value = '散戶買超'
            color = BColor.upcolor
        }

        return <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 0, paddingRight: 0, borderLeft: border }} size="small" align="left">
            <Button size="small" variant="outlined" style={{ minWidth: 140, color: color, marginRight: 1, marginLeft: 1 }} className={classes.button2} >
                {value}
            </Button>
        </TableCell>
    }



    const openDetail = (stockno) => {
        if (props.detailUpdate != undefined) props.detailUpdate(true)
        setStockNo(stockno)
        setOpendetail(true)
    }

    const closeDetail = () => {
        if (props.closeupdate != undefined) props.closeupdate()
        if (props.detailUpdate != undefined) props.detailUpdate(false)
        setOpendetail(false)
    }

    const getAllIds = () => {
        return props.data.map(row => {
            return row.market_company.stock_no
        })
    }

    return (
        <div className={classes.root}>
            <StockDetail open={opendetail} allIds={getAllIds()} handleClose={closeDetail} stockno={stockno} ismobile={props.ismobile} />
            <MyLoveList open={lovemenu} handleClose={handleLoveClose} stockno={getStock} myloveupdate={props.myloveupdate} />

            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}
                    style={{ ...((localStorage.getItem('hfix') == null || localStorage.getItem('hfix') === "y") ? { maxHeight: '70vh' } : {}) }}
                >
                    <Table
                        ref={myContainer}
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >

                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            freecashupdate={props.freecashupdate}
                        />
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .map((row, index) => {
                                    //   const isItemSelected = isSelected(row.stock_no);

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.market_company.stock_no}
                                        >
                                            <TableCell className={classes.stickyc} style={{ borderRight: '1px solid #dbdbdb', borderBottom: '1px solid #d9d9d9' }} padding="none" size="small" align="left">
                                                <Link
    component="button"
    variant="body2"
    onClick={() => {
        openDetail(row.market_company.stock_no)
    }}
    color="inherit"
>{row.market_company.short_name}
</Link>
                                                <br />
                                                <Link
                                                    style={{ color: BColor.upcolor }}
                                                    component="button"
                                                    variant="caption"
                                                    onClick={() => openDetail(row.market_company.stock_no)}
                                                >
                                                    {row.market_company.stock_no}
                                                </Link>
                                            </TableCell>

                                            {row.ebs != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 0 }} size="small"　>
                                                <Button size="small" variant="outlined" style={{ width: '100%', color: BColor.nodatacolor }} className={classes.button2} >
                                                    {row.ebs.ymd}
                                                </Button>
                                            </TableCell> : null}

                                            {row.ebs != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 0 }} size="small"　>
                                                <Button size="small" variant="outlined" style={{ width: '100%', color: BColor.nodatacolor }} className={classes.button2} >
                                                    {row.ebs.t1}張
                                                </Button>
                                            </TableCell> : null}

                                            {row.ebs != undefined ? render2(row.ebs.sb1i, false) : null}
                                            {row.ebs != undefined ? render1(row.ebs.sb1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.ss1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.sbs1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.bb1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.bs1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.bbs1, '張') : null}

                                            {row.ebs == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 0, borderLeft: '1px solid #dbdbdb' }} colSpan="9" size="small"　>
                                                <Button size="small" variant="outlined" style={{ width: '100%', color: BColor.nodatacolor }} className={classes.button2} >
                                                    -
                                                </Button>
                                            </TableCell> : null}


                                            {row.ebs != undefined ? render2(row.ebs.msb1i, true) : null}
                                            {row.ebs != undefined ? render1(row.ebs.msb1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.mss1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.msbs1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.mbb1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.mbs1, '張') : null}
                                            {row.ebs != undefined ? render1(row.ebs.mbbs1, '張') : null}

                                            {row.ebs == undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 0, borderLeft: '1px solid #dbdbdb' }} colSpan="7" size="small"　>
                                                <Button size="small" variant="outlined" style={{ width: '100%', color: BColor.nodatacolor }} className={classes.button2} >
                                                    -
                                                </Button>
                                            </TableCell> : null}

                                            <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 5, paddingRight: 5 }} align="center">
                                                <Button
                                                    size="small"
                                                    onClick={handleLoveClick(row.market_company.stock_no)}
                                                    variant="outlined"
                                                    style={{ width: '100%', color: BColor.faircolor }}
                                                    className={classes.button}
                                                    startIcon={<FavoriteBorder />}
                                                >
                                                    管理
                                                </Button>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                {props.disablepage ?
                    <div><Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                    匯出
                </Button></div>
                    : <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                        <Divider orientation="vertical" flexItem />
                        <Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                            匯出
                        </Button>
                        <Divider orientation="vertical" flexItem />
                        <TablePagination
                            rowsPerPageOptions={getRowPageData(props.width)}
                            component="div"
                            count={props.total}
                            rowsPerPage={props.currentcount}
                            page={props.currentpage}
                            labelRowsPerPage={'每頁'}
                            labelDisplayedRows={({ from, to, count }) => `第${from}筆，共 ${count}筆`}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        /></div>
                }
            </Paper>
        </div>
    );
}

export default withWidth()(BSmallBigDetail);
